const descriptionDetails = {
    "Amazon_Product_Description": "Converting descriptions to attract customers",
    "Carousel_Ad": "Long form ads that convert",
    "Facebook_Ad": "Tailored Ad best suited for your page",
    "Google_Ad": "Convert at the best cost per click possible",
    "Instagram_Ad": "Compelling ad to promote your product and pages",
    "Instagram_Product_Description": `Ecommerce copy to grab buyer's interest instantly`,
    "Linkedin_Ad_text": "Scale your business with the best B2B ads",
    "Ad_Headline": `Compelling headlines to grab user's interest`,
    "Captions": `Enticing captions for your social media posts`,

    "Blog_Ideas": "Interesting ideas to spark engagement",
    "Blog_Intro": "Great introductions for amazing blog posts",
    "Blog_Outline": "Brief outlines to give structure to your post",
    "Blog_Post": "Long form post assistant to write engaging posts",

    "Youtube_Video_Description": "Optimized descriptions for your youtube videos",
    "Ad_ideas": "Innovative ways to grow your brand through ads",
    "AIDA_framework": `Write AIDA centric content for your product`,
    "FAQ_Ideas": `Never run out of ‘What, how’ questions again`,
    "Content_Ideas": "Map out what to create next",
    "Listicle": "Generate a list for any topic",
    "Pain_Benefit_Solution": "Tell audience why your solution is unique and apt for their problem",

    "Brand_essence": "Lines to promote your brand’s vision and mission",
    "Landing_pages": "Pages that convert a visitor to a customer",
    "SEO_Metatag": "Meta to optimize your website on the web",
    "Unique_value_proposition": "Write out the real differentiator of your product/company",

    "Article_Summary": "Summarise a long article at a single click",
    "Pitch_Yourself": " Bring the best out of you in business/personal scenarios",
    "Content_ReWriter": "Enhance your current written text",
    "Short_Sales_Email": "Write emails that convert"
}

export default descriptionDetails;